import React, { useState } from "react";
import "../RequestChange/RequestChange.scss";
import { Modal, Row, Col } from "react-bootstrap";
import { ButtonV1 } from "lib";
import { useSelector } from "react-redux";

import PropTypes from "prop-types";
const SendPaymentLinkModal = (props) => {
  const {
    show,
    onHide,
    requestChangeConfig,
    sendPaymentLink,
    setSendingPaymentLink,
    sendingPaymentLink,
  } = props;

  const [email, setEmail] = useState("");

  const payment_details = useSelector(
    (state) => state.paymentReducer?.payment_details
  );

  const [wrongEmailPatternOccured, setWrongEmailPatternOccured] =
    useState(false);

  const validateEmail = (email) => {
    const re = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;

    return re.test(String(email).toLowerCase());
  };

  const handleSendEmailsToUsersForPayment = () => {
    const emails = email.split(",");
    for (let email of emails) {
      const isValidEmail = validateEmail(email.trim());
      if (!isValidEmail) {
        setWrongEmailPatternOccured(true);
        setSendingPaymentLink(false);
        return false;
      }
    }
    setSendingPaymentLink(true);
    setWrongEmailPatternOccured(false);
    sendPaymentLink(email);
    return true;
  };

  return (
    <Modal
      size="md"
      className=""
      show={show}
      onHide={onHide}
      centered
      scrollable
      backdrop="static"
      // style={{
      //   padding: "4rem",
      //   width: "45vw",
      //   marginLeft: "30vw",
      // }}
    >
      <Modal.Header closeButton className="modal_headers mt-2 mx-2 pb-0 ">
        <Modal.Title className="req_change_title fs-20px fw-bold text-theme">
          {requestChangeConfig?.title
            ? requestChangeConfig?.title
            : "Send Payment Link"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="mx-1 pt-0 mt-0">
        <Row className="row_comments_heading mx-0 mt-4">
          <div className="errorLabeled p-0 m-0">
            {wrongEmailPatternOccured && (
              <span className="errorLabeled">
                {requestChangeConfig?.wrongEmailPatternMessage ||
                  "Please enter valid email address"}
              </span>
            )}
          </div>
          <div className="comments_head mb-1 commentsTextRequestchangeStyle">
            {requestChangeConfig?.label
              ? requestChangeConfig?.label
              : "Enter email address to send payment link"}
          </div>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            type="text"
            className="w-100 border border-1 border-black h-35px"
          />
        </Row>
        <Row className="d-flex buttons_conatiner mt-2">
          <Col
            lg={6}
            xs={6}
            onClick={sendingPaymentLink ? null : onHide}
            className={`backButton ${sendingPaymentLink && "disabled"}`}
          >
            {requestChangeConfig?.buttonCancelLabel
              ? requestChangeConfig?.buttonCancelLabel
              : "Back"}
          </Col>
          <Col lg={6} xs={6} className="send_button">
            {" "}
            <ButtonV1
              label={
                requestChangeConfig?.buttonLabel
                  ? requestChangeConfig?.buttonLabel
                  : "Send"
              }
              className=" primary_button"
              disabled={email?.length === 0}
              onClick={handleSendEmailsToUsersForPayment}
            />
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

SendPaymentLinkModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  requestChangeConfig: PropTypes.object,
  sendPaymentLink: PropTypes.func,
  setSendingPaymentLink: PropTypes.func,
  sendingPaymentLink: PropTypes.bool,
};

export default SendPaymentLinkModal;
